import { InputText } from 'primereact/inputtext';
import { Controller } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import FieldWithErrors from '../../../../../../Forms/ReactHookForm/FieldWithErrors';

function BankAccountField() {
  const { t } = useTranslation();

  return (
    <FieldWithErrors name="smetka" label={t('Bank account')}>
      <Controller
        name="smetka"
        render={({ field }) => (
          <InputText
            id="smetka"
            name="smetka"
            value={field.value}
            onChange={(e) => field.onChange(e.target.value.replace(/\D/g, ''))}
            max={15}
            data-cy="bank_account"
          />
        )}
      />
    </FieldWithErrors>
  );
}

export default BankAccountField;
